import { checkinsApi } from "./checkins.api";

export const {
  useGetCheckinsCompanyActivesByCompanyQuery,
  useGetCheckinsCalledByCompanyQuery,
  useSaveCheckinMutation,
  useSaveCheckinCheckoutMutation,
  useSaveCheckinRootMutation
} = checkinsApi;
